module.exports = __webpack_public_path__ + "static/media/image.77423ca0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/BunburyCentral/image.jpg
// module id = 22
// module chunks = 0